import ComboCounter from '../utils/ComboCounter';

export default class PayLine {
	constructor(scene, line, pay, freeSpins, wild) {
		this.scene = scene;
		this.line = line;
		this.pay = pay;
		this.freeSpins = freeSpins;
		this.useWildInFirstPosition = false;
		this.wild = wild;
	}

	getWildLines() {
		var res = [];
		if (!this.scene.useWild) return res; // return empty list

		var wPoss = this.getPositionsForWild();
		var maxWildsCount = this.useWildInFirstPosition ? wPoss.length - 1 : wPoss.length;
		var minWildsCount = 1;
		var maxCounterValues = [];
		wPoss.forEach(p => {
			maxCounterValues.push(1);
		});

		var cC = new ComboCounter(maxCounterValues);
		while (cC.nextCombo()) {
			var combo = cC.combo;
			var comboSum = cC.sum(); // count of wilds in combo

			if (comboSum >= minWildsCount && comboSum <= maxWildsCount) {
				var p = new PayLine(this.scene, Array.from(this.line), this.pay, this.freeSpins, this.wild);
				for (var i = 0; i < wPoss.length; i++) {
					var pos = wPoss[i];
					if (combo[i] == 1) {
						p.line[pos] = this.wild;
					}
				}

				if (!this.isEqual(p) && !this.containEqualLine(res, p)) res.push(p);
			}
		}
		return res;
	}

	getPositionsForWild() {
		var wPoss = [];
		var counter = 0;

		for (var i = 0; i < this.line.length; i++) {
			var sName = this.line[i];
			if (sName !== 'any' && sName !== this.wild) {
				if (!this.useWildInFirstPosition && counter == 0) {
					// don't use first
					counter++;
				} else {
					if (this.scene.symbolsDict[sName].useWildSubstitute) wPoss.push(i);
					counter++;
				}
			}
		}
		return wPoss;
	}

	isEqual(pLine) {
		if (pLine === null) return false;
		if (pLine.line === null) return false;
		if (this.line.length != pLine.line.length) return false;
		for (var i = 0; i < this.line.length; i++) {
			if (this.line[i] !== pLine.line[i]) return false;
		}
		return true;
	}

	containEqualLine(pList, pLine) {
		if (pList == null) return false;
		if (pLine == null) return false;
		if (pLine.line == null) return false;
		for (var i = 0; i < pList.length; i++) {
			if (pList[i].isEqual(pLine)) return true;
		}
		return false;
	}
}
